import { Module } from "vuex";
import { Question } from "@/models/healthCare/types/question";

interface SurveyState {
  questionData: Question[];
  surveySessionId: string | null;
}

const survey: Module<SurveyState, any> = {
  state: (): SurveyState => ({
    questionData: [],
    surveySessionId: null,
  }),
  mutations: {
    SET_QUESTIONS(state, { questions, sessionId }) {
      state.questionData = questions;
      state.surveySessionId = sessionId;
    },
    UPDATE_ANSWER(state, { questionCode, answer }) {
      const question = state.questionData.find(
        (q) => q.question_code === questionCode
      );
      if (question) {
        question.answer = answer;
      }
    },
    CLEAR_QUESTIONS(state, { sessionId }) {
      if (state.surveySessionId === sessionId) {
        state.questionData = [];
        state.surveySessionId = null;
      }
    },
  },
  actions: {
    updateAnswer({ commit }, payload) {
      commit("UPDATE_ANSWER", payload);
    },
    clearQuestions({ commit }, { sessionId }) {
      commit("CLEAR_QUESTIONS", { sessionId });
    },
  },
  getters: {
    getQuestions:
      (state) =>
        ({ sessionId }: { sessionId: string }) => {
          return state.surveySessionId === sessionId ? state.questionData : [];
        },
  },
};

export default survey;
